import { Hero } from "@/components/site/Hero";
import { Doorways } from "@/components/site/Doorways";
import { Motto } from "@/components/site/Motto";
import { FeaturedIn } from "@/components/site/FeaturedIn";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <div className="max-w-[1500px] mx-auto px-5 sm:px-10"><Motto testid="home-motto" className="!pt-2 sm:!pt-4 !pb-4 sm:!pb-8" /></div>
      <FeaturedIn />
      <Doorways />
    </div>
  );
}
